import { render, staticRenderFns } from "./ManageClientLayout.vue?vue&type=template&id=399d272b"
import script from "./ManageClientLayout.vue?vue&type=script&lang=js"
export * from "./ManageClientLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports